import { createEnum } from '../helpers'

export const AZURE_IMPORT_STATUS_VALUES = [
  'DETECTED',
  'PROCESSING',
  'PROCESSED',
  'COMPLETED',
  'FAILED',
  'FILE_MISSING',
] as const
export const AZURE_IMPORT_STATUS = createEnum(AZURE_IMPORT_STATUS_VALUES)
export type AzureImportStatus = (typeof AZURE_IMPORT_STATUS_VALUES)[number]

export const RETRYABLE_AZURE_IMPORT_STATUSES: ReadonlySet<AzureImportStatus> = new Set([
  'DETECTED',
  'PROCESSED',
  'FAILED',
])

/**
 * The modules that import files from Azure Blob Storage. Each has its own `uploads_from_azure`
 * (`AZURE_IMPORTS_TABLES`), queue (`AZURE_IMPORTS_QUEUES`) and worker source. Credit joins this list
 * when it gets a container; nothing else has to change shape.
 */
export const AZURE_IMPORT_MODULES = ['crt'] as const
export type AzureImportModule = (typeof AZURE_IMPORT_MODULES)[number]
